import trackClick from "@faire/web-api--source/endpoints/www/api/click-track/post";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import { trackEvent } from "@faire/web/common/trackEvent";

export const allMakersMakerClicked = (brandToken: string) => {
  trackEvent(`/all-makers/maker-page/${brandToken}`);
};

export const trackBrandClick = (
  token: string,
  container_name: string,
  request_id?: string
) => {
  trackClick(
    IClickInfo.build({
      token,
      request_id,
      container_name,
      type: IClickInfo.Type.BRAND,
    })
  );
};

export const trackProductClick = (
  token: string,
  container_name: string,
  request_id?: string,
  product_metadata?: IClickInfo.IProductMetadata
) => {
  trackClick(
    IClickInfo.build({
      token,
      request_id,
      container_name,
      type: IClickInfo.Type.PRODUCT,
      product_metadata: product_metadata,
    })
  );
};

export const trackEditCartItemEvent = (
  productQuantityInCart: number,
  newQuantity: number,
  containerName: string,
  productOptionToken: string,
  inSavedForLaterSection?: boolean
) => {
  if (newQuantity !== productQuantityInCart) {
    let action;
    if (newQuantity === 0) {
      action = inSavedForLaterSection
        ? "delete_item_saved_for_later"
        : "delete_item";
    } else if (newQuantity > productQuantityInCart) {
      action = "increase_quantity";
    } else {
      action = "decrease_quantity";
    }

    trackEvent(
      `container/${containerName}/edit_cart_item/${action}/${productOptionToken}`
    );
  }
};
